import Vue from 'vue'
import router from "./router"
import _ from 'lodash'

const storageProp = "sbClassicParams"

const ClassicParams = {

  required: true,

  onReady: null,

  install(Vue, options) {

    this.onReady = new Promise((resolve, reject) => {

      router.onReady((route) => {
        const params = {
          embedMode: false,
          ... route.query
        }
        const assignParamKeys = ['classicHost', 'env', 'embedMode', 'loginToken', 'origin']
        const storedParamKeys = ['classicHost', 'env', 'embedMode']
        // Assign variables we WANT to store in sessionStorage
        _.map(assignParamKeys, (prop) => {
          let value = params[prop]
          if(!_.isNil(value)) {
            Vue.prototype.$classicParams[prop] = value
          }
        })
        // Store param keys in sessionStorage
        sessionStorage.setItem(storageProp, JSON.stringify(_.pick(Vue.prototype.$classicParams, storedParamKeys)))
        // If we have a token, let's set it (but not store it)
        if(params.token) {
          sessionStorage.setItem('token', params.token)
        }
        // Remove all the loading query strings
        router.replace(route.path)
        // Tell any listeners we now have params set
        resolve(Vue.prototype.$classicParams)
      })

      Vue.prototype.$classicParams = JSON.parse(sessionStorage.getItem(storageProp) || '{}')

      Vue.prototype.$classicParams.$destroy = () => {
        sessionStorage.removeItem(storageProp)
      }

    })

  }

}

Vue.use(ClassicParams)

export default ClassicParams



// WEBPACK FOOTER //
// ./src/initializers/classic-params.js